import { Alert, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNotificationsStore } from '@/stores/notificationsStore'

interface LessonStartSoonBannerProps {
  lessonId: number
}

export function LessonStartSoonBanner({ lessonId }: LessonStartSoonBannerProps) {
  const { t } = useTranslation()
  const latest = useNotificationsStore((state) => state.latest)
  const markRead = useNotificationsStore((state) => state.markRead)
  const notification = latest.find(
    (item) =>
      item.event_key === 'lesson.start_soon' &&
      Number(item.meta.lesson_id) === lessonId &&
      item.meta.cancelled !== true,
  )

  if (!notification) return null

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        !notification.read_at ? (
          <Button color="inherit" size="small" onClick={() => void markRead(notification.id)}>
            {t('notifications.markRead')}
          </Button>
        ) : undefined
      }
    >
      <strong>{notification.title}</strong> — {notification.body}
    </Alert>
  )
}
